const megabyteInBytes = 1048576;
const allowedMegabytes = 2;

export const fileSizeValidator = (file: File): boolean => file.size <= megabyteInBytes * allowedMegabytes;
